export default {
    name: 'TriangleRight',
    dimensions: { width: 8, height: 11 },
    content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 9.50001C0.5 9.88441 0.720346 10.2348 1.06681 10.4013C1.41328 10.5678 1.82453 10.521 2.1247 10.2809L7.12469 6.28088C7.36191 6.09111 7.5 5.80379 7.5 5.50001C7.5 5.19623 7.36191 4.90891 7.12469 4.71914L2.12469 0.71914C1.82452 0.479005 1.41328 0.432186 1.06681 0.598706C0.720345 0.765226 0.5 1.1156 0.5 1.50001V9.50001Z" fill="currentColor"/>
    `
};
